import { render, staticRenderFns } from "./ListWidget.vue?vue&type=template&id=42a842b0&scoped=true&"
import script from "./ListWidget.vue?vue&type=script&lang=js&"
export * from "./ListWidget.vue?vue&type=script&lang=js&"
import style0 from "./ListWidget.vue?vue&type=style&index=0&id=42a842b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42a842b0",
  null
  
)

export default component.exports